import GoalAndOperationalPlansOverview from './GoalAndOperationalPlansOverview';

export default GoalAndOperationalPlansOverview;
